import { Reveal } from "@/components/shared/Reveal";
import { motion, useReducedMotion } from "framer-motion";

/** Swiss timeline: a gold hairline, a dot per point, time in display type. */
export const EventProgramme = ({ items = [] }) => {
  const reduce = useReducedMotion();
  if (!items.length) return null;
  return (
    <Reveal as="section" id="program" className="mt-14 scroll-mt-28 border-t border-border pt-10" testId="event-programme">
      <p className="t-mono text-muted-foreground">Program</p>
      <h2 id="programme-title" className="t-h3 mt-2">Slik vert det</h2>
      <ol className="mt-7 border-l-2 border-sol/70 pl-7">
        {items.map((p, i) => (
          <motion.li key={`${p.time || ""}-${p.title}-${i}`} initial={{ opacity: 0, x: reduce ? 0 : -10 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, margin: "-5% 0px" }} transition={{ duration: 0.45, delay: reduce ? 0 : i * 0.05, ease: [0.16, 1, 0.3, 1] }}
            className="relative pb-7 last:pb-0" data-testid={`event-programme-item-${i}`}>
            <span className="absolute -left-[37px] top-[9px] h-3 w-3 rounded-full border-2 border-sol bg-background" aria-hidden="true" />
            <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
              {p.time && <time className="font-display text-[22px] font-semibold tabular tracking-[-0.02em]">{p.time}</time>}
              <h3 className="text-[17px] font-medium">{p.title}</h3>
            </div>
            {p.note && <p className="mt-1 max-w-prose text-[15px] leading-relaxed text-muted-foreground">{p.note}</p>}
          </motion.li>
        ))}
      </ol>
    </Reveal>
  );
};
